import React from 'react';
import { EmailMessage } from '../types';

interface EmailMessageViewProps {
  message: EmailMessage | null;
  loading: boolean;
}

function formatFullDate(isoDate: string): string {
  if (!isoDate) return '';
  const d = new Date(isoDate);
  if (isNaN(d.getTime())) return isoDate;
  return d.toLocaleString([], {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

const EmailMessageView: React.FC<EmailMessageViewProps> = ({ message, loading }) => {
  if (!message && loading) {
    return (
      <div className="email-message-view email-message-view-loading">
        Loading message...
      </div>
    );
  }

  if (!message) return null;

  const bodyLoading = loading && !message.text && !message.html;

  return (
    <div className="email-message-view">
      <div className="email-message-view-header">
        <div className="email-message-view-subject">{message.subject}</div>
        {message.sourceChannelName && (
          <div className="email-message-view-source">
            <span className="email-message-view-label">Source:</span> {message.sourceChannelName}
          </div>
        )}
        <div className="email-message-view-from">
          <span className="email-message-view-label">From:</span> {message.from}
        </div>
        <div className="email-message-view-date">
          <span className="email-message-view-label">Date:</span> {formatFullDate(message.date)}
        </div>
        {message.aiSummary && (
          <div className="email-message-view-summary">
            <span className="email-message-view-label">Summary:</span> {message.aiSummary}
          </div>
        )}
      </div>

      <div className="email-message-view-body">
        {bodyLoading ? (
          <div className="email-message-view-body-loading">Loading message...</div>
        ) : message.html ? (
          <iframe
            className="email-message-view-iframe"
            title="Email content"
            srcDoc={message.html}
            sandbox="allow-same-origin"
          />
        ) : (
          <pre className="email-message-view-text">{message.text || '(no content)'}</pre>
        )}
      </div>
    </div>
  );
};

export default EmailMessageView;
